import * as React from 'react';
import "react-datepicker/dist/react-datepicker.css";
import BarChart from '../Bar';
import Chart from '../Chart';
import Column from '../Column';
import List from '../List';
import Frame from '../Frame';
import IFrame from '../IFrame';
import Pie from '../Pie';
import Column_Pie from '../Column_Pie';
import Bar_List from '../BarList';
import MultiBar_List from '../MultiAxisBar_List';
import Line_List from '../LineList';
import moment from 'moment';
import $ from 'jquery';
import Claim from '../Claim';
import Claim_New from '../Claim_New';
import FilterTagCom from '../FilterTag';
import { userService } from '../../_services';
import { Redirect } from "react-router-dom";
import ColorJson from '../../../src/whitelabel.json';

class DistributorDashboard extends React.Component {
    constructor(props) {
        super(props);
        var startdate = new Date();
        startdate.setDate(startdate.getDate() - 30);
        var enddate = new Date();
        if (localStorage.getItem('User_Start_Date') != "" && localStorage.getItem('User_Start_Date') != null && localStorage.getItem('User_Start_Date') != undefined) {
            startdate = localStorage.getItem('User_Start_Date');
        }
        if (localStorage.getItem('User_End_Date') != "" && localStorage.getItem('User_End_Date') != null && localStorage.getItem('User_End_Date') != undefined) {
            enddate = localStorage.getItem('User_End_Date');
        }
        let filterdatalocal = localStorage.getItem('Advance_Filter');
        if (filterdatalocal == null || filterdatalocal == '' || filterdatalocal == undefined || filterdatalocal == "null") {
            filterdatalocal = '';
        }

        var _roletype = '', _rolename = '';
        var _wh_Id = 0;
        var _Distributor_UserId = 0;

        try {
            var userdata = JSON.parse(localStorage.getItem('user'));
            try { _Distributor_UserId = userdata.distributor_UserId; }
            catch (error) { }
            if (userdata.userrole == "Distributor" && userdata.wholesaler == "Avenel_lll") {
                _roletype = "avdistributor";
                _rolename = userdata.email;
                _wh_Id = userdata.wholesaler_Id;
            }
            else if (userdata.userrole == "Distributor" && userdata.wholesaler != "Avenel_lll") {
                _roletype = "distributor";
                _rolename = userdata.paramsname;
                _wh_Id = userdata.wholesaler_Id;
            }
            else {
                _roletype = userdata.userrole;
                _rolename = userdata.paramsname;
                _wh_Id = userdata.wholesaler_Id;
            }
        }
        catch (error) { }
        this.state = {
            userdata: JSON.parse(localStorage.getItem('user')),
            scrollArray: {},
            graphData: [],
            dashboardName: this.props.dashboardName,
            wholesalerName: this.props.Wholesaler,
            DistributorEmail: this.props.DisEmail,
            IframeBaseURL: "",
            endDate: new moment(enddate).format("YYYYMMDD"),
            startDate: new moment(startdate).format("YYYYMMDD"),
            FilterTagMatch: [],
            FilterTagList: filterdatalocal,
            roletype: _roletype,
            rolename: _rolename,
            wh_Id: _wh_Id,
            distributor_UserId: _Distributor_UserId,
            dist_usertype: this.props.dist_usertype,
            isEnrollEndpointEnabled: false,
            isBrokerDataCount: 0
        };
        let newDate = new Date();
        localStorage.setItem('Filter_Last_Update_Time', newDate);
        this.handlechangea = this.handlechangea.bind(this);
        this.GetBroker_Enrollment_API_Status(this.state.userdata.wholesaler_Id, this.state.userdata.distributor_UserId);
        // this.changeData();
    }
    componentDidMount() {
        $("body").addClass('brokerPage');
        this.GetBroker_Enrollment_API_Status(this.state.userdata.wholesaler_Id, this.state.userdata.distributor_UserId);
        this.changeData();
        setTimeout(function () {
            var $head = $(".widget-iframe").contents().find("head");
            var $body = $(".widget-iframe").contents().find("body");
            $head.append($("<link/>",
                { rel: "stylesheet", href: "/table.css", type: "text/css" }));
            if ($(window).width() < 480) {
                $body.addClass('scrollMobile');
            } else {
                $body.removeClass('scrollMobile');
            }

        }, 1000);

        $(window).resize(function () {
            var $body = $(".widget-iframe").contents().find("body");
            if ($(window).width() < 480) {
                $body.addClass('scrollMobile');
            } else {
                $body.removeClass('scrollMobile');
            }
        });
    }
    componentWillUnmount() {
        $("body").removeClass('brokerPage');
    }
    componentDidUpdate() {
        if (this.state.dist_usertype != this.props.dist_usertype) {
            this.setState({
                dist_usertype: this.props.dist_usertype
            });
            localStorage.setItem('dist_usertype', this.props.dist_usertype);
            this.changeData();
        }
    }
    handlechangea(e) {
        this.props.handeChangefilter(e);
    }
    handleCollapse = () => {
        if ($(".sidebar-section").hasClass("intro")) {
            $(".menu-text").css('width', 'auto');
            $(".sidebar-section").animate({
                width: 270 + 'px'
            }, 1000);
            $(".collapseButton").animate({
                left: 246 + 'px'
            }, 1000, function () {
                $("#chartjs-tooltip").hide();
                $(".collapseButton").removeClass('active');
            });
            $(".dashboardHeading").animate({
                marginLeft: 313 + 'px'
            }, 400);
            $("#dashboard_header_select").animate({
                marginLeft: 0 + 'px'
            }, 1000);
            $("#dashboard-container").animate({
                marginLeft: 13 + 'px'
            }, 1000);
            $(".adjustWidth").css('margin', '0 0 0 65px');
            $(".sidebar-section").removeClass('intro');
            $(".react-bootstrap-daterangepicker-container").animate({
                marginRight: 0 + 'px'
            }, 1000);
            $("#dashboard_header_select").removeClass('full');
        } else {
            $(".sidebar-section").animate({
                width: 90 + 'px'
            }, 1000, function () {
                $(".menu-text").css('width', '0px');
            });
            $(".collapseButton").animate({
                left: 66 + 'px'
            }, 1000, function () {
                $(".collapseButton").addClass('active')
            });
            $(".dashboardHeading").animate({
                marginLeft: 140 + 'px'
            }, 400);
            $("#dashboard_header_select").animate({
                marginLeft: -173 + 'px'
            }, 1000);
            $("#dashboard-container").animate({
                marginLeft: -158 + 'px'
            }, 1000);
            $(".adjustWidth").css('margin', '0 auto');
            $(".sidebar-section").addClass('intro');
            $(".react-bootstrap-daterangepicker-container").animate({
                marginRight: -173 + 'px'
            }, 1000, function () {
                $("#dashboard_header_select").addClass('full');
            });
        }
        var $head8 = $(".widget-iframe").contents().find("head");
        $head8.append($("<link/>",
            { rel: "stylesheet", href: "/table.css", type: "text/css" }));
    }
    changeData() {
        var APIBaseURL = "";
        var APIBaseURL_New = "";
        var APIBaseURL_New_Drug = "";
        var APIBaseURL_Enrollment = "";
        var APIBaseURL_GnWisePaidClaims = "";
        var APIBaseURL_EnrollmentGroup = "";
        var APIBaseURL_ClientAccess = "";
        var APIBaseURL_ClientAccessGroup = "";
        var wname = this.props.dashboardName;
        var startDateObj = this.props.startDate;
        var endDateObj = this.props.endDate;
        var startDate = new moment(startDateObj).format("YYYYMMDD");
        var endDate = new moment(endDateObj).format("YYYYMMDD");
        this.setState({ startDate: startDate });
        this.setState({ endDate: endDate });
        var wholesalername = this.props.Wholesaler;
        var disemail = this.props.DisEmail;
        var AllDirectOverride = this.props.dist_usertype; //this.props.handlechangealldirectoverride;
        if (wname == null || wname == '') {
            wname = this.props.DisName;
        }
        if (AllDirectOverride === 'All') {
            APIBaseURL_Enrollment = '/api/Broker/date_wise_signup_all';
            APIBaseURL_EnrollmentGroup = '/api/Broker/gn_wise_signup_all';
            APIBaseURL_ClientAccess = '/api/Broker/devicedatesignup_all';
            APIBaseURL_ClientAccessGroup = '/api/Broker/devicegnsignup_all';
            APIBaseURL_GnWisePaidClaims = '/api/Broker/gn_wise_paid_trans_all';

            APIBaseURL = '/api/Broker/total_transactions_new_all';
            APIBaseURL_New = '/api/Broker/patient_savings_new_all';
            APIBaseURL_New_Drug = '/api/Broker/drugtransaction_new_all';
        }
        else if (AllDirectOverride === 'Direct') {
            APIBaseURL_Enrollment = '/api/Broker/date_wise_signup';
            APIBaseURL_EnrollmentGroup = '/api/Broker/gn_wise_signup';
            APIBaseURL_ClientAccess = '/api/Broker/devicedatesignup';
            APIBaseURL_ClientAccessGroup = '/api/Broker/devicegnsignup';
            APIBaseURL_GnWisePaidClaims = '/api/Broker/gn_wise_paid_trans';

            APIBaseURL = '/api/Broker/total_transactions_new';
            APIBaseURL_New = '/api/Broker/patient_savings_new';
            APIBaseURL_New_Drug = '/api/Broker/drugtransaction_new';
        }
        else if (AllDirectOverride === 'Override') {
            APIBaseURL_Enrollment = '/api/Broker/date_wise_signup_override';
            APIBaseURL_EnrollmentGroup = '/api/Broker/gn_wise_signup_override';
            APIBaseURL_ClientAccess = '/api/Broker/devicedatesignup_override';
            APIBaseURL_ClientAccessGroup = '/api/Broker/devicegnsignup_override';
            APIBaseURL_GnWisePaidClaims = '/api/Broker/gn_wise_paid_trans_override';

            APIBaseURL = '/api/Broker/total_transactions_new_override';
            APIBaseURL_New = '/api/Broker/patient_savings_new_override';
            APIBaseURL_New_Drug = '/api/Broker/drugtransaction_new_override';
        }
        else {
            APIBaseURL_Enrollment = '/api/Broker/date_wise_signup';
            APIBaseURL_EnrollmentGroup = '/api/Broker/gn_wise_signup';
            APIBaseURL_ClientAccess = '/api/Broker/devicedatesignup';
            APIBaseURL_ClientAccessGroup = '/api/Broker/devicegnsignup';
            APIBaseURL_GnWisePaidClaims = '/api/Broker/gn_wise_paid_trans';

            APIBaseURL = '/api/Broker/total_transactions_new';
            APIBaseURL_New = '/api/Broker/patient_savings_new';
            APIBaseURL_New_Drug = '/api/Broker/drugtransaction_new';
        }
        let newDate = new Date();
        try {
            newDate = localStorage.getItem('Updated_Filter_Status');
        }
        catch (error) {
        }
        var AdFilterJson = '';
        try {
            AdFilterJson = JSON.parse(localStorage.getItem('Advance_Filter'))
            if (AdFilterJson != null && AdFilterJson != '' && AdFilterJson != undefined && AdFilterJson != "null") {
                this.setState({ FilterTagList: JSON.stringify(AdFilterJson) });
            }
            else {
                this.setState({ FilterTagList: '' });
            }
        }
        catch (error) {
            this.setState({ FilterTagList: '' });
        }
        var Request_user = escape(wname.replace(" Dashboard", "").trim());
        var PostData_PatientSaving_True = "{\"wname\"" + ":\"" + this.state.userdata["distributor_UserId"] + "\",\"whname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        var Drug_Transaction_PostData_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["distributor_UserId"] + "\",\"whname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 20 + ",\"chart_type\"" + ":\"" + "pielist\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        var TotalTransaction_PostData_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["distributor_UserId"] + "\",\"whname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        var Analytics_Widget1_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["distributor_UserId"] + "\",\"whname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        var Analytics_Widget2_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["distributor_UserId"] + "\",\"whname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        var MultiAxis_DeviceSignup = "{\"wname\"" + ":\"" + this.state.userdata["distributor_UserId"] + "\",\"whname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "column_multiaxislist\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"widget_link\"" + ":\"" + "" + "\"}";
        var Widget4 = "{\"wname\"" + ":\"" + this.state.userdata["distributor_UserId"] + "\",\"whname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"widget_link\"" + ":\"" + "" + "\"}";
        var Widget5 = "{\"wname\"" + ":\"" + this.state.userdata["distributor_UserId"] + "\",\"whname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"widget_link\"" + ":\"" + "" + "\"}";
        var Widget6 = "{\"wname\"" + ":\"" + this.state.userdata["distributor_UserId"] + "\",\"whname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"widget_link\"" + ":\"" + "" + "\"}";
        var primaryColor;
        var secondaryColor;
        var extraColor;
        if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
            primaryColor = ColorJson.ApplicationColor.Rxhacker_primary_color;
            secondaryColor = ColorJson.ApplicationColor.Rxhacker_secondary_color;
            extraColor = ColorJson.ApplicationColor.Rxhacker_extra_color;
        } else {
            secondaryColor = ColorJson.ApplicationColor.Glic_secondary_color;
            extraColor = ColorJson.ApplicationColor.Glic_extra_color;
            primaryColor = ColorJson.ApplicationColor.Glic_primary_color;
        }
        if (this.state.isEnrollEndpointEnabled == true && this.state.isBrokerDataCount > 0) {
            this.setState({
                user_role_filter: AllDirectOverride,
                dashboardName: wname,
                graphData: [
                    {
                        url: '/api/Broker' + "/date_wise_signup",
                        type: "Bar_List",
                        title: "Total Enrollment Center Signups",
                        Subtitle: "Total number of user signups",
                        ColorCode: secondaryColor,
                        DataType: "NA",
                        XlabelString: "Date",
                        YlabelString: "Number of Signups",
                        interval: 'day',
                        id: "Alalytic_widget_Broker1",
                        BorderRadius: 0,
                        RequestJson: Analytics_Widget1_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: '/api/Broker' + "/gn_wise_signup",
                        type: "Bar_List",
                        title: "Enrollment Center Signups by Group Number",
                        Subtitle: "Total number of signups for each Group Number",
                        ColorCode: secondaryColor,
                        DataType: "NA",
                        XlabelString: "Group Number",
                        YlabelString: "Number of Signups",
                        id: "Alalytic_widget_Broker2",
                        BorderRadius: 0,
                        RequestJson: Analytics_Widget2_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: '/api/Broker' + "/devicedatesignup",
                        type: "MultiBar_List",
                        title: "Client Access Link Signups",
                        Subtitle: "Number of signups through Client Access Links",
                        ColorCode: primaryColor,
                        DataType: "NA",
                        XlabelString: "Date",
                        YlabelString: "Number of Signups",
                        //interval: 'date',
                        id: "Alalytic_widget3",
                        RequestJson: MultiAxis_DeviceSignup,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: '/api/Broker' + "/devicegnsignup",
                        type: "Bar_List",
                        title: "Client Access Link Signups by Group Number",
                        Subtitle: "Number of signups through Client Access Links for each group number",
                        ColorCode: secondaryColor,
                        DataType: "NA",
                        XlabelString: "Group Number",
                        YlabelString: "Number of Signups",
                        //interval: 'date',
                        id: "Alalytic_widget4",
                        RequestJson: Widget4,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: '/api/Broker' + "/date_wise_signup_api",
                        type: "Bar_List",
                        title: "API Signups",
                        Subtitle: "Number of signups through API",
                        ColorCode: secondaryColor,
                        DataType: "NA",
                        XlabelString: "Date",
                        YlabelString: "Number of Signups",
                        interval: 'day',
                        id: "Alalytic_widget5",
                        RequestJson: Widget5,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: '/api/Broker' + "/gn_wise_signup_api",
                        type: "Bar_List",
                        title: "API Signups by Group Number",
                        Subtitle: "Number of signups through API for each group number",
                        ColorCode: secondaryColor,
                        DataType: "NA",
                        XlabelString: "Group Number",
                        YlabelString: "Number of Signups",
                        id: "Alalytic_widget6",
                        RequestJson: Widget6,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: APIBaseURL,
                        type: "Bar_List",
                        title: "Paid Transactions",
                        Subtitle: "Total number of paid transactions for each day",
                        ColorCode: secondaryColor,
                        DataType: "NA",
                        XlabelString: "Date",
                        YlabelString: "# of Transactions",
                        interval: 'day',
                        id: "DTotalTransaction",
                        BorderRadius: 0,
                        RequestJson: TotalTransaction_PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: APIBaseURL_GnWisePaidClaims,
                        type: "Bar_List",
                        title: "Paid Transactions by Group Number",
                        Subtitle: "Total number of paid transactions for each group number",
                        ColorCode: secondaryColor,
                        DataType: "NA",
                        XlabelString: "Group Number",
                        YlabelString: "# of Transactions",
                        id: "GroupPaidTransaction",
                        BorderRadius: 0,
                        RequestJson: Analytics_Widget2_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: APIBaseURL_New,
                        type: "Bar_List",
                        title: "Total Patient Savings ($)",
                        Subtitle: "Total savings for all patients in $",
                        ColorCode: secondaryColor,
                        XlabelString: "Date",
                        YlabelString: "Average Saving",
                        id: "DMetric3A",
                        Broker: true,
                        BorderRadius: 0,
                        RequestJson: PostData_PatientSaving_True,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: APIBaseURL_New_Drug,
                        type: "Column_Pie",
                        title: "Top 20 Compensable Drugs",
                        Subtitle: "Number of transactions for each drug",
                        ColorCode: extraColor,
                        DataType: "DrugName",
                        id: "WDrugTransaction",
                        RequestJson: Drug_Transaction_PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    }
                ]
            });
        }
        else {
            this.setState({
                user_role_filter: AllDirectOverride,
                dashboardName: wname,
                graphData: [
                    {
                        url: APIBaseURL_Enrollment,
                        type: "Bar_List",
                        title: "Total Enrollment Center Signups",
                        Subtitle: "Total number of user signups",
                        ColorCode: secondaryColor,
                        DataType: "NA",
                        XlabelString: "Date",
                        YlabelString: "Number of Signups",
                        interval: 'day',
                        id: "Alalytic_widget_Broker1",
                        BorderRadius: 0,
                        RequestJson: Analytics_Widget1_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: APIBaseURL_EnrollmentGroup,
                        type: "Bar_List",
                        title: "Enrollment Center Signups by Group Number",
                        Subtitle: "Total number of signups for each Group Number",
                        ColorCode: secondaryColor,
                        DataType: "NA",
                        XlabelString: "Group Number",
                        YlabelString: "Number of Signups",
                        id: "Alalytic_widget_Broker2",
                        BorderRadius: 0,
                        RequestJson: Analytics_Widget2_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: APIBaseURL_ClientAccess,
                        type: "MultiBar_List",
                        title: "Client Access Link Signups",
                        Subtitle: "Number of signups through Client Access Links",
                        ColorCode: primaryColor,
                        DataType: "NA",
                        XlabelString: "Date",
                        YlabelString: "Number of Signups",
                        //interval: 'date',
                        id: "Alalytic_widget3",
                        RequestJson: MultiAxis_DeviceSignup,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: APIBaseURL_ClientAccessGroup,
                        type: "Bar_List",
                        title: "Client Access Link Signups by Group Number",
                        Subtitle: "Number of signups through Client Access Links for each group number",
                        ColorCode: secondaryColor,
                        DataType: "NA",
                        XlabelString: "Group Number",
                        YlabelString: "Number of Signups",
                        //interval: 'date',
                        id: "Alalytic_widget4",
                        RequestJson: Widget4,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: APIBaseURL,
                        type: "Bar_List",
                        title: "Paid Transactions",
                        Subtitle: "Total number of paid transactions for each day",
                        ColorCode: secondaryColor,
                        DataType: "NA",
                        XlabelString: "Date",
                        YlabelString: "# of Transactions",
                        interval: 'day',
                        id: "DTotalTransaction",
                        BorderRadius: 0,
                        RequestJson: TotalTransaction_PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: APIBaseURL_GnWisePaidClaims,
                        type: "Bar_List",
                        title: "Paid Transactions by Group Number",
                        Subtitle: "Total number of paid transactions for each group number",
                        ColorCode: secondaryColor,
                        DataType: "NA",
                        XlabelString: "Group Number",
                        YlabelString: "# of Transactions",
                        id: "GroupPaidTransaction",
                        BorderRadius: 0,
                        RequestJson: Analytics_Widget2_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: APIBaseURL_New,
                        type: "Bar_List",
                        title: "Total Patient Savings ($)",
                        Subtitle: "Total savings for all patients in $",
                        ColorCode: secondaryColor,
                        XlabelString: "Date",
                        YlabelString: "Average Saving",
                        id: "DMetric3A",
                        Broker: true,
                        BorderRadius: 0,
                        RequestJson: PostData_PatientSaving_True,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: APIBaseURL_New_Drug,
                        type: "Column_Pie",
                        title: "Top 20 Compensable Drugs",
                        Subtitle: "Number of transactions for each drug",
                        ColorCode: extraColor,
                        DataType: "DrugName",
                        id: "WDrugTransaction",
                        RequestJson: Drug_Transaction_PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    }
                ]
            });
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    GetBroker_Enrollment_API_Status(Wh_Id, distributor_UserId) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Wh_Id, distributor_UserId })
            };
            return fetch(`/api/Broker/getBroker_Enrollment_API_Status`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            this.setState({ isEnrollEndpointEnabled: apidata[0].colValue });
                            this.setState({ isBrokerDataCount: apidata[0].row_Count });
                            this.changeData();
                        }
                        else {
                            this.changeData();
                        }
                    }
                    catch (error) {
                        this.setState({ loading: false, error: 'Error. Please try later.', IsResetDone: true });
                        this.changeData();
                        return false;
                    }
                });
        }
        catch (error) {
            this.setState({ loading: false, error: 'Error. Whoops, something went wrong. Please try again.', IsResetDone: true });
            return false;
        }
    }
    render() {
        var user_role_filter = this.state.user_role_filter;
        var startDateObj = this.props.startDate;
        var startDate = new moment(startDateObj).format("YYYYMMDD");
        var endDateObj = this.props.endDate;
        var endDate = new moment(endDateObj).format("YYYYMMDD");
        var IsCall = false;
        try {
            if ((localStorage.getItem('Prev_Filter_Status').toLowerCase() != localStorage.getItem('Updated_Filter_Status').toLowerCase()) || (localStorage.getItem('Prev_AdFilter_Status') != localStorage.getItem('Updated_AdFilter_Status')) || (localStorage.getItem('Updated_HD_Type') != localStorage.getItem('Prev_HD_Type'))) {
                IsCall = true;
            }
            else {
                IsCall = false;
            }
        }
        catch (error) {
            IsCall = false;
        }
        try {
            if (endDate != this.state.endDate || startDate != this.state.startDate || IsCall == true) {
                if (IsCall == true) {
                    localStorage.setItem('Prev_Filter_Status', localStorage.getItem('Updated_Filter_Status'));
                    if (localStorage.getItem('Updated_AdFilter_Status') == "null" || localStorage.getItem('Updated_AdFilter_Status') == null) {
                        localStorage.setItem('Prev_AdFilter_Status', null);
                        localStorage.setItem('Updated_AdFilter_Status', null);
                    }
                    else {
                        localStorage.setItem('Prev_AdFilter_Status', localStorage.getItem('Updated_AdFilter_Status'));
                    }
                    if (localStorage.getItem('Updated_HD_Type') == "null" || localStorage.getItem('Updated_HD_Type') == null) {
                        localStorage.setItem('Prev_HD_Type', null);
                        localStorage.setItem('Updated_HD_Type', null);
                    }
                    else {
                        localStorage.setItem('Prev_HD_Type', localStorage.getItem('Updated_HD_Type'));
                    }
                }
                this.changeData();
            }
        } catch (error) {
        }
        const a = [];
        // eslint-disable-next-line no-unused-expressions
        a[0] = { height: 570, width: 1100 },
            a[1] = { height: 170, width: 550 },
            a[2] = { height: 170, width: 550 }

        try {
            let usertype = userService.Get_User_Type();
            if (userService.Check_LoggedIn_Status() == 'Login') {
                return <Redirect to="/login" />
            }
            if (usertype.toLowerCase() == 'wholesaler') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'admin') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'subadmin') {
                return <Redirect to='/pageNotFound' />
            }
        } catch (error) { }
        return (
            <div className="dashboard-content-parent">
                <div className="newBoard">
                    <div className="parent">
                        <div className="contentContainer">
                            <div>
                                <div className='row'>
                                    <div className='double-column'>
                                        <div className="dashboard-container" id="dashboard-container">
                                            <a href="javascript:void('0')" className="collapseButton" onClick={this.handleCollapse}>Collapse Button</a>
                                            <FilterTagCom dist_id={this.state.distributor_UserId} Rolename={this.state.rolename} wh_Id={this.state.wh_Id} Roletype={this.state.roletype} df={this.state.startDate} dt={this.state.endDate} handlechangea={this.handlechangea} FilterTags={this.state.FilterTagList} />
                                            {
                                                this.state.graphData.map((item, index) => {
                                                    return (
                                                        ((this.state.wholesalerName.toLowerCase() == 'Avenel_llll' && item.title == 'Total Commission Earned' && item.type == "MultiBar_List") || (this.state.wholesalerName.toLowerCase() != 'Avenel_llll' && item.title == 'Total Commission Earned' && item.type == "Bar_List")) ? null :
                                                            <div id={item.id + index} className={`${item.type == "Bar" ? "widget ui-draggable ui-resizable" : item.type == "Line" ? "widget ui-draggable ui-resizable second" : "widget ui-draggable ui-resizable customScroll third barlist"}${item.id == "DTotalTransaction" ? ' layout-not-margin' : ''}${item.id == "GroupPaidTransaction" ? ' layout-left-margin' : ''}${item.id == "Alalytic_widget_Broker1" ? ' layout-not-margin' : ''}${item.id == "Alalytic_widget_Broker2" ? ' layout-left-margin' : ''}${item.id == "Alalytic_widget3" ? ' layout-not-margin' : ''}${item.id == "Alalytic_widget4" ? ' layout-left-margin' : ''}${item.id == "DMetric3A" ? ' layout-not-margin' : ''}${item.id == "WDrugTransaction" ? ' layout-left-margin' : ''}${item.id == "Alalytic_widget5" ? ' layout-not-margin' : ''}${item.id == "Alalytic_widget6" ? ' layout-left-margin' : ''}`} key={"graph-widget" + index}>
                                                                <div className="widget-content" key={"graph-widget-content" + index}>
                                                                    <div className="custom-scroll">
                                                                        <div className="scroll-content" style={{ height: this.state.scrollArray[this.state.graphData[index].id] }}>
                                                                            {item.type == "Bar" ? <BarChart data={item} key={"bargraph" + index} ColorCode={item.ColorCode} XlabelString={item.XlabelString} YlabelString={item.YlabelString} _Index={index} /> : null}
                                                                            {item.type == "Chart" || item.type == "Line" ? <Chart data={item} key={"linegraph" + index} XlabelString={item.XlabelString} YlabelString={item.YlabelString} _Index={index} /> : null}
                                                                            {item.type == "Column" ? <Column data={item} key={"columngraph" + index} XlabelString={item.XlabelString} YlabelString={item.YlabelString} _Index={index} /> : null}
                                                                            {item.type == "List" ? <List data={item} key={"listgraph" + index} _Index={index} handlechangea={this.handlechangea} /> : null}
                                                                            {item.type == "Pie" ? <Pie data={item} key={"piegraph" + index} _Index={index} /> : null}
                                                                            {item.type == "Column_Pie" ? <Column_Pie data={item} key={"columnpiegraph" + index} _Index={index} handlechangea={this.handlechangea} /> : null}
                                                                            {item.type == "Bar_List" ? <Bar_List data={item} key={"barlistgraph" + index} _Index={index} handlechangea={this.handlechangea} /> : null}
                                                                            {item.type == "Line_List" ? <Line_List data={item} key={"linelistgraph" + index} _Index={index} /> : null}
                                                                            {item.type == "MultiBar_List" ? <MultiBar_List data={item} key={"barlistgraph1" + index} _Index={index} /> : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="widget-foot">
                                                                    &nbsp;
                                                                        </div>
                                                            </div>
                                                    )
                                                })
                                            }

                                        </div>

                                    </div>
                                    <div className='column filter-section'>
                                        <div className="dashboard-container" id="dashboard-container">
                                            <IFrame url={this.state.IframeBaseURL} title="Filter" class="" />
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default DistributorDashboard;
